import {
	FeeCalculator,
	PerMeasurementCalculator,
	FixedPriceCalculator,
	PerItemCalculator,
} from './BaseCalculator.js';

export default class CalculatorFactory {
	constructor(params) {
		this.params = params;
	}

	create(priceType, value, calculationType) {
		let calculator = null;
		switch (calculationType) {
			case 'fee':
				calculator = new FeeCalculator(priceType, value);
				calculator.setParams(this.params);
				return calculator;
			case 'per_measurement':
				calculator = new PerMeasurementCalculator(priceType, value);
				calculator.setParams(this.params);
				return calculator;
			case 'fixed_price':
				calculator = new FixedPriceCalculator(priceType, value);
				calculator.setParams(this.params);
				return calculator;
			case 'per_item':
			default:
				calculator = new PerItemCalculator(priceType, value);
				calculator.setParams(this.params);
				return calculator;
		}
	}
}
